/**
 ** FAQ Block JS
 **/
document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    const header = item.querySelector(".accordion-header");
    const content = item.querySelector(".accordion-content");
    const icon = item.querySelector(".plus-minus");

    // Check if the accordion item has the 'open' class to set it as opened
    if (item.classList.contains("open")) {
      content.style.maxHeight = content.scrollHeight + "px";
      icon.classList.add("toggled");
    }

    header.addEventListener("click", function () {
      const isActive = content.style.maxHeight;

      if (isActive) {
        // Close the item if it's already open
        content.style.maxHeight = null;
        icon.classList.remove("toggled");
      } else {
        // Open the clicked item
        content.style.maxHeight = content.scrollHeight + "px";
        icon.classList.add("toggled");
      }
    });
  });
});
